



<h4 mat-dialog-title>
  <ng-container *ngIf="this.lang == 'de-DE'">
    Merkliste
  </ng-container>

  <ng-container *ngIf="this.lang == 'fr-FR'">
    Favoris
  </ng-container>
  
</h4>


<div class="row">
<div class="col-md-12">
  <ul id="GFG" class="merkliste-container">
    <li *ngFor="let document of documents">
      <app-list-item class="my-3" [document]="document" (infoRequest)="onInfoRequest($event)"></app-list-item>
      <mat-divider class="my-3"></mat-divider>
    </li>
  </ul>
</div>


<div class="col-md-12">
  
  <button class="mb-5" (click)="printDocs()" mat-stroked-button
  color="primary"><mat-icon aria-hidden="false" aria-label="Example home icon">print</mat-icon>
  
  
  <ng-container *ngIf="this.lang == 'de-DE'">
    Drucken
  </ng-container>
  
  <ng-container *ngIf="this.lang == 'fr-FR'">
    Imprimer
  </ng-container>
  
  
  </button>
  
  <p *ngIf="documents.length === 0">
   Derzeit sind keine Dokumente hinzugefügt.
  </p>

</div>
  
  
  

</div>
